/* Fitvids */
fitvids()
$(".fluid-width-video-wrapper").wrap("<div class='fluid-width-video-wrapper-max-width'></div>");
